import { Flex, Form, Input, FormContext } from 'dash-ui';
import { ChangeEvent, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FormFields } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants';
import useValidation from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/hooks/useValidation';

const CityInput = () => {
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { formState, formErrors, stateHandlers } = useContext(FormContext);
  const valid = useValidation();

  const onChange =
    (fieldName: FormFields) => (e: ChangeEvent<HTMLInputElement>) => {
      stateHandlers[fieldName](e.target.value);
      valid(fieldName, e.target.value);
    };

  return (
    <Flex flex={1} flexDirection="column" mr={2}>
      <Form.Label required>{t('forms:labels.city')}</Form.Label>
      <Input
        w="100%"
        value={formState.city || ''}
        placeholder={t('forms:placeholders.nameOfCity') || ''}
        onChange={onChange(FormFields.City)}
        $errorType={formErrors[FormFields.City]?.type}
      />
      <Form.Feedback $errorType={formErrors[FormFields.City]?.type}>
        {formErrors[FormFields.City]?.message}
      </Form.Feedback>
    </Flex>
  );
};

export default CityInput;
